/* eslint-disable */
import { BASE_URL } from 'config/main';

import { TENANT } from 'constants/misc';

import vertx from './vertx';

var eb = null;
var reqisterQueue = [];
var registered = [];

// reconnection attempt interval;
// will go from MIN to MAX, for consecutive fails;
// will be reset to MIN once we have a successful connection;
var RECONNECT_INTERVAL_MIN = 0;
var RECONNECT_INTERVAL_MAX = 60000;
var RECONNECT_INTERVAL_STEP = 5000;
var reconnectInterval = RECONNECT_INTERVAL_MIN;

var _giveUp = false;

var AysistEventBus = {
  register: function (eventBusUrl, callback) {
    eventBusUrl = TENANT + eventBusUrl;
    if (_giveUp) {
      _giveUp = false;
      this.reInitAll();
    }

    if (eb && eb.readyState() === vertx.EventBus.OPEN) {
      eb.registerHandler(eventBusUrl, callback);
      registered.push({ eventBusUrl: eventBusUrl, callback: callback });
      console.log('Just registered handler for %s', eventBusUrl);
    } else {
      reqisterQueue.push({ eventBusUrl: eventBusUrl, callback: callback });
    }
  },
  unregister: function (eventBusUrl, handler) {
    eventBusUrl = TENANT + eventBusUrl;
    if (eb && eb.readyState() === vertx.EventBus.OPEN) {
      eb.unregisterHandler(eventBusUrl, handler);
      // delete handler from registered
      for (var i = 0; i < registered.length; i++) {
        var item = registered[i];
        if (item.eventBusUrl === eventBusUrl && item.callback === handler) {
          registered.splice(i, 1);
        }
      }
      console.log('Just unregistered handler for %s', eventBusUrl);
    }
  },
  getRegistered: function () {
    return registered;
  },
  isRegistered: function (eventBusUrl, handler) {
    const registeredObj = registered.find((item) => {
      return (
        item.eventBusUrl.includes(eventBusUrl) && item.callback === handler
      );
    });

    return !!registeredObj;
  },
  close: function () {
    if (eb.readyState() === vertx.EventBus.OPEN) {
      eb.close();
    }
  },
  reInitAll: function () {
    if (eb === null || eb.readyState() !== vertx.EventBus.OPEN) {
      eb = new vertx.EventBus(`${BASE_URL}/eventbus`);
      eb.onclose = onclose;
      eb.onopen = function () {
        console.log('Re-opened!');
        onopen.call();
        for (var i = 0; i < registered.length; i++) {
          var item = registered[i];
          eb.registerHandler(item.eventBusUrl, item.callback);
          console.log('Registered again handler for %s', item.eventBusUrl);
        }
        reconnectInterval = RECONNECT_INTERVAL_MIN;
      };
    }
  },
  giveUp: function () {
    _giveUp = true;
    registered = [];
  }
};

var onopen = function () {
  console.log('Connnected at %O', new Date());

  // Register handlers that we tried to initialize before the connection was open
  while (reqisterQueue.length > 0) {
    var handler = reqisterQueue.pop();
    AysistEventBus.register(handler.eventBusUrl, handler.callback);
  }
};

var onclose = function (error) {
  console.log('On close error ' + JSON.stringify(error));
  console.log('Connection closed at %O', new Date());
  eb = null;

  if (!_giveUp) {
    // Only show message if after a few tries to reconnect, we couldn't
    if (reconnectInterval !== RECONNECT_INTERVAL_MIN) {
      // TODO emit message
      // on.emit(window, 'eventbus.closed', {
      //     bubbles: true,
      //     cancelable: true
      // });
    }

    setTimeout(function () {
      AysistEventBus.reInitAll();
    }, reconnectInterval);

    reconnectInterval =
      reconnectInterval > RECONNECT_INTERVAL_MAX
        ? RECONNECT_INTERVAL_MAX
        : reconnectInterval + RECONNECT_INTERVAL_STEP;

    // If we reached the end of the reconnect interval, give up
    if (reconnectInterval >= RECONNECT_INTERVAL_MAX) {
      AysistEventBus.giveUp();
    }
  }
};

eb = new vertx.EventBus(`${BASE_URL}/eventbus`, {
  vertxbus_ping_interval: 2000
});
eb.onopen = onopen;
eb.onclose = onclose;

export default AysistEventBus;
